






























import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class StepControls extends Vue {
  @Prop({ default: true })
  private hr!: boolean;

  @Prop({ default: true })
  private back!: boolean;

  @Prop({ default: true })
  private next!: boolean;

  @Prop({ default: true })
  private continue!: boolean;

  @Prop({ default: false })
  private enabled!: boolean;

  @Prop({ default: () => i18n.t("_action.back") })
  private backButtonText!: boolean;

  @Prop({ default: () => i18n.t("_.continue") })
  private nextButtonText!: boolean;

  @Prop({ default: false })
  private processing!: boolean;
}
